import { useState, useContext, useEffect, useRef } from "react";
import ApiContext from "src/provider/API/call-service";
import utility from "src/utils/utility";
import {
  AppText,
  CustomContainer,
  FlexColumn,
  FlexRow,
  ScreenContainer,
} from "src/style";
import { ReportFilter, ServerSideTable } from "src/component";
import { manageSurveyColumn } from "src/utils/tableLayout";
import { ISurveyTriggers } from "src/model";
import { useTranslation } from "react-i18next";
import { NewSurveyTrigger } from "./popups/new-survey-trigger";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { useNavigate } from "react-router-dom";

const ManageSurvey = () => {
  const { t } = useTranslation();
  const { setInfoProperty } = useContext(AppInfoContext);
  const navigate = useNavigate();

  const { API, downloadReport } = useContext(ApiContext);
  const [reportData, setReportData] = useState<any>(null);
  const [report, setReport] = useState<any>(null);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [resetPagination, setResetPagination] = useState<boolean>(false);
  const [selectedInstitution, setSelectedInstitution] = useState<string>("");
  const [surveyTriggers, setSurveyTriggers] = useState<ISurveyTriggers[]>([]);
  const [showAddTrigger, setShowAddTrigger] = useState<boolean>(false);
  const [selectedInstitutionName, setSelectedInstitutionName] =
    useState<string>("");

  const handleSelection = async (data: any) => {
    await setInfoProperty("selectedInstitutionName", selectedInstitutionName);
    await setInfoProperty("selectedInstitutionCode", selectedInstitution);
    await setInfoProperty("selectedSurveyTrigger", data);
    navigate("/dashboard/survey-details");
  };

  const filterDataRef = useRef({});

  async function fecthTriggers() {
    if (selectedInstitution) {
      const response = await API.getSurveyTriggers(selectedInstitution);
      if (response) setSurveyTriggers(response);
    }
  }

  function handleClear() {
    filterDataRef.current = {};
    // handleFetchReport();
    setResetPagination(!resetPagination);
  }

  useEffect(() => {
    filterDataRef.current = {};
    // handleFetchReport();
    fecthTriggers();
  }, [selectedInstitution]);

  return (
    <>
      <ScreenContainer>
        <CustomContainer topMargin="3" className="no-submenu-container">
          <ServerSideTable
            tableData={surveyTriggers || []}
            tableColumns={manageSurveyColumn(t, handleSelection)}
            dataFetchMethod={fecthTriggers}
            totalRows={surveyTriggers?.length}
            tableTitle={t("manageSurvey.surveyManagement")}
            customStyle
            shouldResetPagination={resetPagination}
            selectInstitution
            canFilter={false}
            canClear={false}
            downloadAction={false}
            onInstitutionSelect={(value: any) => {
              setSelectedInstitution(value?.value);
              setSelectedInstitutionName(value?.label);
              fecthTriggers();
            }}
            showSurvey={false}
            showCreate={true}
            setShowAddTriggger={() => setShowAddTrigger(true)}
          />
        </CustomContainer>
      </ScreenContainer>

      {showAddTrigger && (
        <NewSurveyTrigger
          isEdit={false}
          ibInstitutionCode={Number(selectedInstitution)}
          close={() => setShowAddTrigger(false)}
          refetchTriggers={fecthTriggers}
        />
      )}
    </>
  );
};

export default utility.routeData(
  "survey-management",
  "ManageSurvey",
  <ManageSurvey />
);
